
import objectPath from 'object-path'
import moment from 'moment'

import { services } from '@/utils/constants'

const getters = {
  // поля не [] - это легаси, из-за смены форматы на бэке, это необходимо для для бронирования
  getIds: state => ({
    hotels: state.hotels.reduce((ids, hotel) => [...ids, {
      accommodationSearchId: hotel.accommodations.searchId,
      id: hotel.info.id,
      accommodationId: hotel.accommodations.current.id
    }], []),
    hotel: {
      hotelId: state.hotels.length ? state.hotels[0].info.id : null,
      accommodationSearchId: state.hotels.length ? state.hotels[0].accommodations.searchId : null,
      accommodationId: state.hotels.length ? state.hotels[0].accommodations.current.id : null,
    },
    insurances: state.insurances.reduce((ids, insurance) => [...ids, {
      searchId: insurance.insurances.searchId,
      resultId: insurance.insurances.current.slug
    }], []),
    medicalInsurance: {
      insuranceSearchId: state.insurances.length && state.insurances[0].insurances.current.slug
        ? state.insurances[0].insurances.searchId
        : null,
      insuranceResultId: state.insurances.length
        ? state.insurances[0].insurances.current.slug
        : null,
    },
    transfers: state.transfers.reduce((ids, transfer) => [...ids, {
      searchId: transfer.transfers.searchId,
      id: transfer.transfers.current.transferId,
      vehicleId: transfer.transfers.current.vehicleId
    }], []),
    transfer: {
      transferSearchId: state.transfers.length
        ? state.transfers[0].transfers.searchId
        : null,
      vehicleId: state.transfers.length
        ? state.transfers[0].transfers.current.vehicleId
        : null,
      transferId: state.transfers.length
        ? state.transfers[0].transfers.current.transferId
        : null,
    },
    cancelInsurance: {
      sumPerPerson: state.cancelInsurances.length
        ? state.cancelInsurances[0].form.sumPerPerson
        : null,
      currency: (
        state.cancelInsurances.length && state.cancelInsurances[0].form.sumPerPerson !== null
      )
        ? state.insurances[0].insurances.current.price.currency
        : null,
    },
    flights: state.flights.reduce((ids, flight) => [...ids, {
      searchId: flight.aviatickets.searchId,
      recommendationId: flight.aviatickets.current.id
    }], []),
    aviaticket: {
      aviaSearchId: state.flights.length
        ? state.flights[0].aviatickets.searchId
        : null,
      recommendationId: state.flights.length
        ? state.flights[0].aviatickets.current.id
        : null,
    },
    excursion: {
      // excursionSearchId: state.excursion.excursions.searchId,
      // excursions: state.excursion.selected.map(excursion => ({
      //   excursionId: excursion.current.slug,
      //   date: moment.unix(excursion.current.timeStart).format('DD.MM.YYYY'),
      //   time: moment.unix(excursion.current.timeStart).format('HH:MM')
      // }))
      excursionSearchId: null,
      excursions: [{
        excursionId: null,
        date: '15.05.2020',
        time: '12:00'
      }]
    },
    visa: {
      visaSearchId: state.visas.length
        ? state.visas[0].visas.searchId
        : null,
      startDate: state.hotels.length ? state.hotels[0].form.checkInDate : null,
      endDate: state.hotels.length
        ? moment(state.hotels[0].form.checkInDate, 'DD.MM.YYYY').add(state.hotels[0].form.duration, 'days').format('DD.MM.YYYY')
        : null
    },
  }),
  getServiceField: state => target => objectPath.get(state, target),
  getMainService: state => state.mainService,
  mainServiceAreLoaded: (state) => {
    const mainService = state.mainService

    const targets = {
      hotels: 'hotels.0.accommodations.current.id',
      aviaticket: 'flights.0.aviatickets.current.id',
      transfer: 'transfers.0.transfers.current.slug',
      insurance: 'insurances.0.insurances.current.slug',
      tours: 'hotels.0.info.id'
    }

    return mainService ? Boolean(objectPath.get(state, targets[mainService])) : false
  },
  getDates: state => state.dates,
  getLocations: state => state.locations,
  getCartServices: (state) => {
    const servicesList = []
    const mainService = state.mainService === 'tours' ? 'hotels' : state.mainService

    services.forEach((item) => {
      const {
        amount,
        markup
      } = state[item.service].reduce((sum, itemService) => ({
        amount: sum.amount + itemService[item.module].current.price.amount,
        markup: sum.markup + itemService[item.module].current.price.markup
      }), { amount: 0, markup: 0 })

      servicesList.push({
        name: item.name,
        main: item.service === mainService,
        key: item.service,
        amount,
        markup,
      })
    })

    return servicesList
  },
  // eslint-disable-next-line
  getCartPrice: (state, getters) => {
    const mainService = state.mainService === 'tours' ? 'hotels' : state.mainService

    const {
      amount,
      markup
    } = getters.getCartServices.reduce((sum, service) => ({
      amount: sum.amount + service.amount,
      markup: sum.markup + service.markup
    }), { amount: 0, markup: 0 })

    const {
      service,
      module
    } = services.find(item => item.service === mainService)

    const currency = state[service].length
      ? state[service][0][module].current.price.currency
      : null

    return {
      amount,
      amountAgency: amount - markup,
      markup,
      currency
    }
  },
  getServiceModuleErrors: state => target => ({
    hasError: objectPath.get(state, `${target}.hasError`),
    errorsList: objectPath.get(state, `${target}.errors`)
  }),
  getServicePenalties: state => target => objectPath.get(state, `${target}.penalties`),
  getAllPenalties: (state) => {
    const objPenalties = state.allPenalties
    const penalties = Object.keys(objPenalties)
      .map(key => objPenalties[key])
      .reduce((arr, service) => [...arr, ...service], [])
    const threeDays = 86400 * 3
    const today = moment().unix()
    const datesOfPenalties = penalties.reduce(
      (arrDate, service) => [...arrDate, ...service.collection.map(penalty => penalty.from)], []
    )
    const hasTodayOrOldPenalties = datesOfPenalties.some(date => (date <= today))
    const firstPenaltyDay = Math.min(...datesOfPenalties)

    return {
      penalties,
      hasTodayOrOldPenalties,
      firstPenaltyDay: firstPenaltyDay <= (today + threeDays)
        ? firstPenaltyDay
        : (today + threeDays)
    }
  }
}

export default getters